/*
 * @Author: your name
 * @Date: 2021-05-18 12:21:17
 * @LastEditTime: 2021-07-28 19:32:01
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \vue_admin\src\permission.js
 */
import router from './router'
import store from './store'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { getToken } from '@/utils/auth' // get token from cookie
import getPageTitle from '@/utils/get-page-title'

import Watermark from '@/utils/watermark'

NProgress.configure({
  showSpinner: false
}) // NProgress Configuration

const whiteList = ['/login', '/register', '/404'] // no redirect whitelist

router.beforeEach(async(to, from, next) => {
  // start progress bar
  NProgress.start()
  // set page title
  document.title = getPageTitle(to.meta.title)
  // determine whether the user has logged in
  const hasToken = getToken()
  if (hasToken) {
    if (to.path === '/login' || to.path === '/register') {
      // if is logged in, redirect to the home page
      next({
        path: '/'
      })
      NProgress.done()
    } else {
      const hasGetUserInfo = store.getters.name
      if (hasGetUserInfo) {
        next()
      } else {
        // 没有用户权限
        try {
          // const { roles } = await store.dispatch('user/getInfo')

          const { watermark } = await store.dispatch('user/getInfo')
          if (watermark != null) {
            Watermark.set(watermark)
          }

          // 权限列表
          const { data } = await store.dispatch('user/getPermissionsList')

          if (undefined != data && data.length > 0) {
            // 获取权限下的router
            const accessRoutes = await store.dispatch(
              'permission/generateRoutes',
              data
            )
            // 添加到路由中去
            router.addRoutes(accessRoutes)
          }
          router.addRoutes([
            {
              path: '*',
              redirect: '/404',
              hidden: true
            }
          ])
          next({
            ...to,
            replace: true
          })
        } catch (error) {
          // remove token and go to login page to re-login
          console.log(error)
          await store.dispatch('user/resetToken')
          // Message.error(error || 'Has Error')
          next(`/login?redirect=${to.path}`)
          NProgress.done()
        }
      }
    }
  } else {
    /* has no token*/
    // console.log('has no token :' + to.path)
    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      next()
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next(`/login?redirect=${to.path}`)
      NProgress.done()
    }
  }
})

router.afterEach((to, from) => {
  // console.log('afterEach', to, from)
  // if (transition.to.title) {
  //   document.title = transition.to.title
  // }
  // finish progress bar
  NProgress.done()
})
